export default "__VITE_ASSET__CX_k8qCX__"